/**
 * Обёртка над сгенерированными operationId шаблонов смен.
 * packages/api-client не править; generate:api в этом эпике не запускать.
 */
import {
  adminShiftTemplatesCreate as sdkCreate,
  adminShiftTemplatesDelete as sdkDelete,
  adminShiftTemplatesGetList as sdkGetList,
  adminShiftTemplatesGetOne as sdkGetOne,
  adminShiftTemplatesUpdate as sdkUpdate,
} from '@pro-sto/api-client';
import type {
  CreateShiftTemplateDto,
  ShiftTemplate,
  ShiftTemplatesListResponse,
  UpdateShiftTemplateDto,
} from '@/types/shift.types';

export const adminShiftTemplatesGetList = (
  serviceCenterUuid: string,
): Promise<ShiftTemplatesListResponse> =>
  sdkGetList({ serviceCenterUuid }) as Promise<ShiftTemplatesListResponse>;

export const adminShiftTemplatesCreate = (
  requestBody: CreateShiftTemplateDto,
): Promise<ShiftTemplate> =>
  sdkCreate({ requestBody }) as Promise<ShiftTemplate>;

export const adminShiftTemplatesGetOne = (uuid: string): Promise<ShiftTemplate> =>
  sdkGetOne({ uuid }) as Promise<ShiftTemplate>;

export const adminShiftTemplatesUpdate = (
  uuid: string,
  requestBody: UpdateShiftTemplateDto,
): Promise<ShiftTemplate> =>
  sdkUpdate({ uuid, requestBody }) as Promise<ShiftTemplate>;

export const adminShiftTemplatesDelete = (uuid: string): Promise<unknown> =>
  sdkDelete({ uuid });
